import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { shopApi } from '../../api/shop';
import { useAuth } from '../../auth/AuthProvider';
import { RequireShop } from '../../components/ShopSelector';
import { LoadingState, PageHeader } from '../../components/Layout';
import { useShop } from '../../context/ShopContext';
import { formatRole } from '../../utils/format';

export default function ShopOverview() {
  const { getToken } = useAuth();
  const { selectedShop, selectedShopId } = useShop();
  const [stats, setStats] = useState({ products: 0, orders: 0, customers: 0 });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selectedShopId) {
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const token = await getToken();
        const [products, orders, customers] = await Promise.all([
          shopApi.listProducts(token, selectedShopId),
          shopApi.listOrders(token, selectedShopId),
          shopApi.listCustomers(token, selectedShopId),
        ]);
        if (!cancelled) {
          setStats({
            products: products.length,
            orders: orders.length,
            customers: customers.length,
          });
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [getToken, selectedShopId]);

  return (
    <RequireShop>
      <PageHeader
        title={selectedShop?.shop.name || 'Overview'}
        description={
          selectedShop
            ? `Signed in as ${formatRole(selectedShop.role)}`
            : 'Select a store to continue.'
        }
      />

      {loading ? (
        <LoadingState />
      ) : (
        <>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="label">Products</div>
              <div className="value">{stats.products}</div>
            </div>
            <div className="stat-card">
              <div className="label">Orders</div>
              <div className="value">{stats.orders}</div>
            </div>
            <div className="stat-card">
              <div className="label">Customers</div>
              <div className="value">{stats.customers}</div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <h3 style={{ margin: '0 0 0.75rem', fontSize: '1rem' }}>Quick links</h3>
              <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                <Link to="/shop/products" className="btn btn-secondary">
                  Manage products
                </Link>
                <Link to="/shop/categories" className="btn btn-secondary">
                  Categories
                </Link>
                <Link to="/shop/orders/new" className="btn btn-secondary">
                  Create order
                </Link>
                <Link to="/shop/customers" className="btn btn-secondary">
                  Manage customers
                </Link>
              </div>
            </div>
          </div>
        </>
      )}
    </RequireShop>
  );
}
